/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".TABLITA[_ngcontent-%COMP%]{width:100%}.example-container[_ngcontent-%COMP%]{height:500px;overflow:auto}\n/*# sourceMappingURL=reportes.component.css.map*/"];
export { styles as styles };
